var _path, _path2, _path3, _path4, _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path5, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path6, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _circle2, _path7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect20, _rect21, _rect22, _rect23, _rect24, _circle3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle4, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ada6f7ae-8394-4767-8700-18704e9e9034",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 974,
    height: 805.02,
    viewBox: "0 0 974 805.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "note list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1087,816.24v5a19.11,19.11,0,0,1-20.91,19c-39.15-3.72-78.12-10.64-117.4-9.43-72.42,2.21-145.44,31.83-215.54,13.53-19.77-5.16-39.32-14.13-59.66-12.2-18.25,1.73-34.49,12.05-52.17,16.89C567.55,863.79,512.8,826.49,457.06,828c-36.74,1-71.92,18.89-108.62,16.9-21.27-1.14-41.53-8.92-62.28-13.71-51.66-11.94-104.86-5.27-158.09-1.13A14,14,0,0,1,113,816.13v-4.28a14,14,0,0,1,14-14l940.92-.76A19.11,19.11,0,0,1,1087,816.24Z",
    transform: "translate(-113 -47.49)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1087,816.24v5a19.11,19.11,0,0,1-20.91,19c-39.15-3.72-78.12-10.64-117.4-9.43-72.42,2.21-145.44,31.83-215.54,13.53-19.77-5.16-39.32-14.13-59.66-12.2-18.25,1.73-34.49,12.05-52.17,16.89C567.55,863.79,512.8,826.49,457.06,828c-36.74,1-71.92,18.89-108.62,16.9-21.27-1.14-41.53-8.92-62.28-13.71-51.66-11.94-104.86-5.27-158.09-1.13A14,14,0,0,1,113,816.13v-4.28a14,14,0,0,1,14-14l940.92-.76A19.11,19.11,0,0,1,1087,816.24Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1087,807.1v5a20.39,20.39,0,0,1-.11,2.08,19.11,19.11,0,0,1-20.8,17c-39.15-3.73-78.12-10.65-117.4-9.44-72.42,2.22-145.44,31.84-215.54,13.53-19.77-5.16-39.32-14.13-59.66-12.2-18.25,1.73-34.49,12.05-52.17,16.9-53.77,14.72-108.52-22.58-164.26-21.08-36.74,1-71.92,18.89-108.62,16.91-21.27-1.15-41.53-8.92-62.28-13.72-51.65-11.93-104.86-5.26-158.09-1.12a14,14,0,0,1-14.86-11.5A13.7,13.7,0,0,1,113,807v-4.28a14,14,0,0,1,14-14l235.83-.19,481.81-.4,223.28-.18A19.11,19.11,0,0,1,1087,807.1Z",
    transform: "translate(-113 -47.49)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M856.59,791c0,2.21-4.36,4.33-12.4,6.32C812,805.27,721,811,613.59,811c-105.67,0-195.58-5.55-229-13.31-9-2.09-14-4.34-14-6.69,0-.82.6-1.63,1.78-2.43l481.81-.4C855.77,789.1,856.59,790,856.59,791Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#36334a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 26,
    width: 93,
    height: 21,
    fill: "#ba2545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 60,
    width: 285,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 84,
    width: 114,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 98.51,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#36334a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 124.51,
    width: 93,
    height: 21,
    fill: "#36334a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 158.51,
    width: 285,
    height: 11,
    fill: "#36334a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 182.51,
    width: 114,
    height: 11,
    fill: "#36334a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 98.51,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#36334a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 124.51,
    width: 93,
    height: 21,
    fill: "#ba2545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 158.51,
    width: 285,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 182.51,
    width: 114,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 667.58,
    y: 211.54,
    width: 10.31,
    height: 85.02,
    rx: 2.29,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 324.76,
    y: 144.93,
    width: 5.79,
    height: 27.99,
    rx: 1.5,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 324.55,
    y: 196.17,
    width: 6.52,
    height: 48.72,
    rx: 1.69,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 324.65,
    y: 261.94,
    width: 6.21,
    height: 49.14,
    rx: 1.61,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 328.04,
    y: 52.43,
    width: 345.1,
    height: 701.37,
    rx: 35.69,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 467.3,
    y: 73.38,
    width: 48.19,
    height: 9.79,
    rx: 2.54,
    fill: "#e6e8ec"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 528.33,
    cy: 78.27,
    r: 5.55,
    fill: "#e6e8ec"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M764.83,145.6v610A27.41,27.41,0,0,1,737.42,783H489.76a27.41,27.41,0,0,1-27.41-27.4v-610a27.41,27.41,0,0,1,27.41-27.41h37.06V123a22.58,22.58,0,0,0,22.57,22.57h126A22.57,22.57,0,0,0,697.91,123v-4.76h39.51A27.41,27.41,0,0,1,764.83,145.6Z",
    transform: "translate(-113 -47.49)",
    fill: "#36334a"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 129,
    width: 31,
    height: 4,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 136,
    width: 31,
    height: 4,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 143,
    width: 31,
    height: 4,
    fill: "#3f3d56"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 129,
    width: 31,
    height: 4,
    fill: "#3f3d56"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 136,
    width: 31,
    height: 4,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 143,
    width: 31,
    height: 4,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M750.66,186.49h-.91l-.35-.29a7.61,7.61,0,0,0,1.78-4.89,7.44,7.44,0,1,0-7.4,7.48,7.73,7.73,0,0,0,4.88-1.78l.34.29v.92l5.74,5.75,1.72-1.72Zm-6.88,0a5.18,5.18,0,1,1,5.16-5.18A5.15,5.15,0,0,1,743.78,186.49Z",
    transform: "translate(-113 -47.49)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 200,
    width: 93,
    height: 21,
    fill: "#ba2545"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 234,
    width: 285,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 258,
    width: 114,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 444,
    width: 93,
    height: 21,
    fill: "#ba2545"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 478,
    width: 285,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 502,
    width: 114,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 566,
    width: 93,
    height: 21,
    fill: "#ba2545"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 600,
    width: 285,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 624,
    width: 114,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 592,
    cy: 676,
    r: 34,
    fill: "#ba2545"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M722.33,720.81v16.43a1.25,1.25,0,0,1-1.25,1.25h-33.5a1.25,1.25,0,0,1-1.25-1.25V711.07a1.25,1.25,0,0,1,1.25-1.25h23.31",
    transform: "translate(-113 -47.49)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 579.67,
    y1: 672,
    x2: 602.33,
    y2: 672,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 676.67,
    x2: 602.67,
    y2: 676.67,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 580.33,
    y1: 681.33,
    x2: 603,
    y2: 681.33,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 605,
    y1: 661,
    x2: 605,
    y2: 672.33,
    fill: "none",
    stroke: "#f0f",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 610.67,
    y1: 666.67,
    x2: 599.33,
    y2: 666.67,
    fill: "none",
    stroke: "#f0f",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 605,
    y1: 661,
    x2: 605,
    y2: 672.33,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 610.67,
    y1: 666.67,
    x2: 599.33,
    y2: 666.67,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.6,792.66c3-5.51-.4-12.27-4.29-17.18s-8.61-10-8.51-16.29c.15-9,9.7-14.31,17.33-19.09a84,84,0,0,0,15.56-12.51,22.8,22.8,0,0,0,4.78-6.4c1.58-3.52,1.54-7.52,1.44-11.37q-.51-19.26-1.91-38.49",
    transform: "translate(-113 -47.49)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.51,670.63a14,14,0,0,0-7-11.5l-3.14,6.22.1-7.53a14.22,14.22,0,0,0-4.63-.56,14,14,0,1,0,14.68,13.37Z",
    transform: "translate(-113 -47.49)",
    fill: "#57b894"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.48,765.62a14,14,0,1,1,.68-11.3l-8.77,7.13,9.65-2.23A14,14,0,0,1,1015.48,765.62Z",
    transform: "translate(-113 -47.49)",
    fill: "#57b894"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.55,738.37a14,14,0,0,1-4.45-27.53l-.08,5.78,3.18-6.29h0a14,14,0,0,1,14.67,13.36,13.84,13.84,0,0,1-.6,4.79A14,14,0,0,1,1008.55,738.37Z",
    transform: "translate(-113 -47.49)",
    fill: "#57b894"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.62,715.7a14,14,0,1,1,6.21-26.27l-2.48,6.8,5.1-4.9A14,14,0,0,1,1056,701a13.79,13.79,0,0,1-.35,3.87A14,14,0,0,1,1042.62,715.7Z",
    transform: "translate(-113 -47.49)",
    fill: "#57b894"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.62,674.37c-3.24.35-6.39,1.36-9.64,1.56s-6.82-.57-8.88-3.1c-1.1-1.36-1.66-3.08-2.59-4.57a10,10,0,0,0-3.54-3.33,14,14,0,1,0,26.24,9.32Q1039.42,674.28,1038.62,674.37Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.62,715.7a14,14,0,0,1-13.35-20,10.37,10.37,0,0,1,2.82,2.82c1,1.51,1.61,3.26,2.78,4.64,2.19,2.57,5.92,3.41,9.31,3.26s6.66-1.12,10-1.43c.47,0,.94-.07,1.42-.08A14,14,0,0,1,1042.62,715.7Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.55,738.37a14,14,0,0,1-13.46-19.76,11.48,11.48,0,0,1,3,2.85c1.09,1.54,1.77,3.32,3.05,4.74,2.37,2.63,6.35,3.56,9.93,3.48s6.83-.93,10.28-1.2A14,14,0,0,1,1008.55,738.37Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.48,765.62a14,14,0,0,1-25.59-11.45,13.84,13.84,0,0,1,3.08,2.75c1.34,1.62,2.22,3.47,3.76,5,2.87,2.82,7.5,4,11.63,4.09A60,60,0,0,0,1015.48,765.62Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M980.43,786.31s11.08-.34,14.42-2.72,17-5.21,17.86-1.4,16.65,19,4.15,19.06-29.06-1.94-32.4-4S980.43,786.31,980.43,786.31Z",
    transform: "translate(-113 -47.49)",
    fill: "#656380"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.08,799.93c-12.51.1-29.06-1.95-32.39-4-2.54-1.55-3.55-7.09-3.89-9.65h-.37s.7,8.94,4,11,19.89,4.07,32.4,4c3.61,0,4.85-1.31,4.78-3.21C1021.14,799.19,1019.77,799.9,1017.08,799.93Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M755,378.52v82.94a19,19,0,0,1-19,19H462.35v-121H736A19,19,0,0,1,755,378.52Z",
    transform: "translate(-113 -47.49)",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 295,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#f2f2f2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 295,
    width: 402,
    height: 121,
    rx: 19.03,
    fill: "#f2f2f2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 321,
    width: 93,
    height: 21,
    fill: "#ba2545"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 355,
    width: 285,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 379,
    width: 114,
    height: 11,
    fill: "#ba2545",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.34,
    cy: 246.84,
    r: 35.75,
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.6,572.43c3.69,25.89-.81,52.29-7.82,77.48-1.31,4.69-2.72,9.42-5.17,13.63s-5.86,7.83-8.74,11.79c-6,8.26-9.52,18-12.81,27.64a779.65,779.65,0,0,0-22.82,81.32,5.57,5.57,0,0,0,0,3.47c.87,2,3.51,2.26,5.68,2.25l28.06-.15c1-1.92-.85-4-2-5.84-4-6.22-.16-14.3,3.37-20.81a223.74,223.74,0,0,0,19.78-50c1.92-7.33,3.48-14.82,6.6-21.73,3.77-8.38,9.68-15.59,14.48-23.43,5.58-9.11,9.65-19,13.69-28.93,5.64-13.78,11.33-27.73,13.55-42.45,2.09-13.82,1.06-27.9-.3-41.81a2.64,2.64,0,0,0-3.06-3l-37.65-1.94c-7.76-.4-9.6-2.1-8.42,5.52C181.84,561.13,183.78,566.67,184.6,572.43Z",
    transform: "translate(-113 -47.49)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M184.6,572.43c3.69,25.89-.81,52.29-7.82,77.48-1.31,4.69-2.72,9.42-5.17,13.63s-5.86,7.83-8.74,11.79c-6,8.26-9.52,18-12.81,27.64a779.65,779.65,0,0,0-22.82,81.32,5.57,5.57,0,0,0,0,3.47c.87,2,3.51,2.26,5.68,2.25l28.06-.15c1-1.92-.85-4-2-5.84-4-6.22-.16-14.3,3.37-20.81a223.74,223.74,0,0,0,19.78-50c1.92-7.33,3.48-14.82,6.6-21.73,3.77-8.38,9.68-15.59,14.48-23.43,5.58-9.11,9.65-19,13.69-28.93,5.64-13.78,11.33-27.73,13.55-42.45,2.09-13.82,1.06-27.9-.3-41.81a2.64,2.64,0,0,0-3.06-3l-37.65-1.94c-7.76-.4-9.6-2.1-8.42,5.52C181.84,561.13,183.78,566.67,184.6,572.43Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M192,509.48c-7.65,11-15.67,23.66-13.13,36.83,1.93,10,9.55,17.75,16.74,25,28.74,28.86,57,60.92,66.78,100.47,2.52,10.22,3.74,20.71,5.91,31,3.94,18.7,11,36.58,18,54.35l18.72,47.38a28.36,28.36,0,0,0,27.1-18c-2.46-.19-5.67-2.57-7.11-4.57-8-11.07-9.64-25.31-11.69-38.81-2.27-14.92-5.3-29.72-8.34-44.51L291.58,633.2c-1.55-7.55-3.1-15.11-5.12-22.54-7.82-28.83-22.64-56-24.93-85.81-.34-4.38-.55-9.19-3.52-12.44-3.12-3.43-8.24-4-12.87-4.27C226.41,506.9,210.25,505.07,192,509.48Z",
    transform: "translate(-113 -47.49)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.47,783.62a29.86,29.86,0,0,0-6.22-.8,12.92,12.92,0,0,0-10.16,5.55,25.25,25.25,0,0,0-2.73,6l-2.71,7.78c-.8,2.28-1.58,4.91-.39,7A7.42,7.42,0,0,0,122.9,812c6.56,2.92,13.95,3.08,21.1,3.78,6.94.68,13.82,1.9,20.67,3.19,2.36.44,4.71.89,7.1,1.13,5.34.54,10.72,0,16.06-.48l5.51-.53a19.84,19.84,0,0,0,5.42-1,6.83,6.83,0,0,0,4-3.59c1.36-3.37-1.56-7.36-5.13-8-1.45-.29-2.95-.16-4.42-.35a20.88,20.88,0,0,1-4.84-1.45c-7.05-2.77-14.17-5.57-20.37-9.93-1.72-1.21-3.52-2.9-3.33-5a10.19,10.19,0,0,1,.89-2.59,9.46,9.46,0,0,0,.08-6.69c-.34-.92-1-1.89-1.93-2-2.64-.32-2.32,3.53-2.71,5-.53,2-1.49,2.18-3.37,2C152.23,784.91,146.83,784.64,141.47,783.62Z",
    transform: "translate(-113 -47.49)",
    fill: "#f2f2f2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M299.34,810.45a17.65,17.65,0,0,0,3.82,10.75,8.36,8.36,0,0,0,2.72,2.19,10.92,10.92,0,0,0,4.95.79,40.05,40.05,0,0,0,13.89-2.81,39.7,39.7,0,0,1,4.8-1.81,53.88,53.88,0,0,1,6.24-.9c8.27-1.19,15.53-6.07,23.52-8.54a49.45,49.45,0,0,0,7-2.3c3.16-1.49,5.72-4,8.23-6.43a19.89,19.89,0,0,0,3.78-4.52c1.47-2.74,1.56-6,1.62-9.1a2.59,2.59,0,0,0-.24-1.41,2.1,2.1,0,0,0-.9-.71c-2.43-1.2-5.31-.6-8-.13-9.72,1.73-19.67,1.41-29.54,1.09a4.29,4.29,0,0,1-4.54-2.59l-3.75-6c-1.07-1.72-2.77-3.69-4.71-3.1-1.55.47-2.18,2.37-2.12,4s.56,3.25.25,4.84a6.61,6.61,0,0,1-3.2,4.16,20.44,20.44,0,0,1-5,1.92c-5.52,1.56-11.94,3.33-16.21,7.39C298.86,800.15,299.15,806.6,299.34,810.45Z",
    transform: "translate(-113 -47.49)",
    fill: "#f2f2f2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M297.4,413.75a23.17,23.17,0,0,0,5.46-5.94,24.21,24.21,0,0,0,2.33-8.21l1.57-9.92c.87-5.47,1.89-11.26,5.54-15.43s10.92-5.66,14.63-1.54c1.62,1.79,2.26,4.25,2.66,6.64a48.34,48.34,0,0,1-11.82,40c-4.49,4.92-10,8.83-14.75,13.48-4.14,4-7.73,8.59-11.55,12.94A159.42,159.42,0,0,1,260,473.27c.14-7.44,1.09-15.42,0-22.81-.81-5.34-3-8.22,2.17-11.71C274.17,430.59,286.28,423.21,297.4,413.75Z",
    transform: "translate(-113 -47.49)",
    fill: "#fbbebe"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.56,340.57c-.39,5.32-2.6,10.76-7,13.83q18.69,6.54,36.87,14.42c-2.34-2.25-3.05-5.7-3.16-8.94-.31-8.47,2.62-16.8,6.9-24.1a5.85,5.85,0,0,0,1.13-3.18c-.14-2.36-2.94-3.45-5.24-4a128.86,128.86,0,0,0-23.92-3.47c-3.45-.11-7.54-1.2-6.76,3.19C196.12,332.42,196.87,336.42,196.56,340.57Z",
    transform: "translate(-113 -47.49)",
    fill: "#fbbebe"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.66,
    cy: 266.7,
    r: 29.23,
    fill: "#fbbebe"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M249.6,393.14a35.36,35.36,0,0,0-3.71-6.22c-5.3-7.61-10.74-15.21-17.54-21.51a109.19,109.19,0,0,0-16.65-12.23,37.79,37.79,0,0,0-10.42-5,40.77,40.77,0,0,0-6.69-.91l-7.59-.62a6.21,6.21,0,0,0-2,.06c-2.06.52-3,3.08-2.56,5.15s2,3.75,3.38,5.32c.34,15.49-6.55,30.77-7.48,46.24-1.63,27,14.88,52.21,16.2,79.28a8.55,8.55,0,0,1-.38,3.63c-.22.56-.55,1.07-.8,1.62-.78,1.7-.75,3.63-.89,5.5a27.94,27.94,0,0,1-8.23,17.62,12.23,12.23,0,0,0,4.64,3.54c3.19,1.39,7,1.51,10.39,2.48,8.84,2.58,17.9,5.18,27.09,4.63a23.9,23.9,0,0,0,2.09-7.87c1.3-.81,2.8.92,3,2.44s-.09,3.29,1,4.39,2.47.93,3.8.76c5.61-.71,11-2.6,16.5-3.87s11.38-1.88,16.73-.06c1.08-1.37.62-3.4-.26-4.9s-2.13-2.82-2.63-4.49a10.08,10.08,0,0,1-.32-2.95c0-8.55,1.76-17.19.09-25.58-.49-2.46-1.27-4.86-1.77-7.33-1-4.79-.85-9.73-.72-14.62s-.46-10.18-.56-15.14a48.29,48.29,0,0,0-.4-6.13c-.34-2.13-1-4.21-1.18-6.36-.54-5.46,1.66-10.88,1.33-16.36C262.51,405.33,252.84,400.81,249.6,393.14Z",
    transform: "translate(-113 -47.49)",
    fill: "#ff6584"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.63,389.22c-7.08,18.78-10.54,38.7-14,58.48l-8,46.46c-2.27,13.13-4.55,26.34-4.46,39.66,0,3.74.24,7.55-.74,11.16-1.28,4.74-4.46,8.69-6.87,13a42.78,42.78,0,0,0-4.6,28.93c.82,4.15,3.06,8.86,7.27,9.34,3.46.38,6.45-2.37,8.47-5.21,4.64-6.51,6.94-14.37,9-22.11a500.11,500.11,0,0,0,13.87-77.09,75.06,75.06,0,0,1,1.39-9.8,69.54,69.54,0,0,1,3.38-9.76q4.59-11.38,9.19-22.76c7.07-17.53,14.18-35.14,23.89-51.36-9.6-2.76-19.59-6-29.19-8.73C189.46,388.61,186.49,389.1,183.63,389.22Z",
    transform: "translate(-113 -47.49)",
    fill: "#fbbebe"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M200.27,403.46c-6.72-1.45-13.67-1-20.53-1.17a4.43,4.43,0,0,1-2.76-.72c-1.39-1.19-.8-3.42-.1-5.11l3.32-8a11.64,11.64,0,0,1,2.66-4.42c1.69-1.5,4.07-1.87,6.31-2.14,7.29-.84,14.79-1.12,21.86.85s13.72,6.45,16.88,13.08c1.32,2.76,1.93,6.24.18,8.75-2.6,3.73-8.43,7.9-12.78,5.86C210.1,408,206.11,404.73,200.27,403.46Z",
    transform: "translate(-113 -47.49)",
    fill: "#ff6584"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M236,268.79a29.52,29.52,0,0,0-16.28,4.69,35.75,35.75,0,0,0-35.1-8.22A20.43,20.43,0,1,0,161,288.91,35.75,35.75,0,1,0,229.57,309a32,32,0,0,0,6.41.65c14.1,0,25.54-9.15,25.54-20.43S250.08,268.79,236,268.79Z",
    transform: "translate(-113 -47.49)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M241.09,299.43a31.1,31.1,0,0,1-6.41-.65A35.57,35.57,0,0,1,230,309.07a32.11,32.11,0,0,0,6,.58c13.18,0,24-8,25.39-18.24C256.7,296.29,249.35,299.43,241.09,299.43Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M200.23,325a35.8,35.8,0,0,1-34.18-46.28,20.43,20.43,0,0,1-16.89-20.12,20.09,20.09,0,0,1,.33-3.66,20.43,20.43,0,0,0,11.46,34,35.75,35.75,0,0,0,68.29,21.18A35.68,35.68,0,0,1,200.23,325Z",
    transform: "translate(-113 -47.49)",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage);
export default __webpack_public_path__ + "static/media/HomeImage.66e42ea06ed2c6b87306c0e9941158f4.svg";
export { ForwardRef as ReactComponent };